var map = {
	"./1.jpg": 1883,
	"./2.jpg": 1871,
	"./3.jpg": 9593,
	"./4.jpg": 4243,
	"./5.jpg": 8607,
	"./6.jpg": 6134,
	"./7.jpg": 4693,
	"./8.jpg": 6175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8341;